import React from "react";
import { Modal, Button, Typography } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

const UserCancelConfirmModal = ({ isOpen, onClose, onConfirm, requestData, loading }) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={400}
      zIndex={1070}
      centered
      closable={false}
    >
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <ExclamationCircleOutlined style={{ fontSize: "48px", color: "#faad14", marginBottom: "16px" }} />
        <Title level={4}>Cancel Trip Request?</Title>
        <Text type="secondary" style={{ display: "block", marginBottom: "24px" }}>
          Are you sure you want to cancel your trip request to <strong>{requestData?.dest || 'your destination'}</strong>? This action cannot be undone.
        </Text>
        
        <div style={{ display: "flex", justifyContent: "center", gap: "12px", width: "100%" }}>
          <Button onClick={onClose} style={{ flex: 1 }} disabled={loading}>Back</Button>
          <Button className="ouber-btn-danger" onClick={onConfirm} style={{ flex: 1, margin: 0 }} loading={loading}>
            Confirm Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UserCancelConfirmModal;
